class JournalDetails extends React.Component {


    render() {
        var selected = this.props.selected;

        return (
            <div className='journal-details'>

                
            </div>
        );
    }
}

export default JournalDetails;



// WEBPACK FOOTER //
// ./ui_src/app/components/popup/journal/JournalDetails.react.jsx